import React, { Suspense, useMemo, useState } from 'react'
import { FormattedMessage } from 'react-intl'
import ErrorBoundary from 'src/components/ErrorBoundary/ErrorBoundary'
import Loading from 'src/components/Loading/Loading'
import SearchInput from 'src/components/SearchInput/SearchInput'
import DateCell from 'src/components/Table/CellComponents/DateCell'
import FormattedCell from 'src/components/Table/CellComponents/FormattedCell'
import Table from 'src/components/Table/Table'
import { useAssetActivity } from 'src/hooks/api'
import { useExportAssetData } from 'src/util/exportXlsx'
import { filterAssetActivities } from 'src/util/filters'

const ActivityAsset = ({ slug }: {slug: string}) => {
  const activity = useAssetActivity(slug)
  const [filter, setFilter] = useState('')
  const filteredActivity = useMemo(() => activity.filter(filterAssetActivities(filter)), [activity, filter])
  const exportXlsx = useExportAssetData(slug, `assetActivity_${slug}`)

  return (
    <div id="activity-asset">
      <div className="utilities">
        <SearchInput value={filter} onChange={setFilter} />
        <button onClick={exportXlsx} className="export">
          <FormattedMessage id="user.export" />
          <span className="icon icon-excel" />
        </button>
      </div>
      <Table
        name={'activity'}
        data={filteredActivity}
        columns={[
          { name: 'abonado' },
          { name: 'action', component: FormattedCell },
          { name: 'fullname' },
          { name: 'dateAction', component: DateCell }
        ]}
      />
    </div>
  )
}

const ActivityAssetWrapper = (props) =>
  <ErrorBoundary fallback={<FormattedMessage id="error.activity" />}>
    <Suspense fallback={<Loading />}>
      <ActivityAsset {...props} />
    </Suspense>
  </ErrorBoundary>

export default ActivityAssetWrapper
